<template>
    <div>
        <v-row no-gutters>
            <v-col cols="12" md="6" >
                <v-simple-table dense>
                    <tbody>
                        <tr>
                            <th>Code</th>
                            <td>{{ value.code }}</td>
                        </tr>
                        <tr>
                            <th>Date</th>
                            <td>{{ value.date }}</td>
                        </tr>
                        <tr>
                            <th>Warehouse</th>
                            <td>{{ value && value.warehouse ? value.warehouse.display_name : null}}</td>
                        </tr>
                        
                    </tbody>
                </v-simple-table>
            </v-col>
            <v-col cols="12" md="6" >
                <v-simple-table dense>
                    <tbody>
                        <tr>
                            <th>State</th>
                            <td>
                                <PStatus :state="value.state" v-if="value"/>
                            </td>
                        </tr>
                        <tr>
                            <th>Purchase Order</th>
                            <td>
                                    <span class="text-decoration-underline font-weight-bold" @click="showPurchaseOrder" style="cursor: pointer">
                                {{ value && value.purchase_order? value.purchase_order.code : null}}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <th>Supplier</th>
                            <td>{{value && value.purchase_order? value.purchase_order.supplier.display_name : null }}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="12">
                <v-simple-table dense>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Item</th>
                            <th>Quantity</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(l, i) in lines" :key="i">
                            <td>{{i+1}}</td>
                            <td>{{ l.item }}</td>
                            <td>
                                {{ (l.quantity) }} {{ l.measure_unit }}
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <v-simple-table dense>
                    <tbody>
                        <tr>
                            <th>Created By</th>
                            <td>
                                <span v-if="value.created_by">
                                    {{value.created_by.name}}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <th>Created At</th>
                            <td>{{value.created_at}}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
            <v-col cols="12" md="6">
                <v-simple-table dense>
                    <tbody>
                        <tr>
                            <th>Updated By</th>
                            <td>
                                <span v-if="value.updated_by">
                                    {{value.updated_by.name}}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <th>Updated At</th>
                            <td>{{value.updated_at}}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import {formatNumber} from './../../utils/accounting';
import PStatus from './../common/PStatus';

export default {
    name: "GoodReceipt",
    components: {
        PStatus
    },
    props: {
        value: Object
    },
    methods: {
        formatNumber(n) {
            return formatNumber(n, 2);
        },
        showPurchaseOrder() {
            this.$router.push({ name: "PurchaseOrderDisplay", params: { id: this.value.purchase_order.id } });
        }
    },
    computed: {
        lines() {
            if(!this.value.lines) return [];
            return this.value.lines.map(line => ({
               item: `${line.item.code} - ${line.item.name}`,
               quantity: line.quantity,
               measure_unit: line.measure_unit.abbreviation
            }))
        }
    },
}
</script>

<style>

</style>